import { useNavigate } from "react-router-dom";

import {
  BookOpen,
  Calculator,
  ClipboardCheck,
  FileBarChart,
  FileSpreadsheet,
  GitCompareArrows,
  History,
  Receipt,
  Scale,
  TrendingUp,
  Wallet,
} from "lucide-react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";

interface ReportCard {
  title: string;
  description: string;
  icon: React.ElementType;
  url: string;
  available: boolean;
}

const reports: ReportCard[] = [
  {
    title: "Libro Diario",
    description:
      "Registro cronológico de todas las transacciones contables publicadas.",
    icon: BookOpen,
    url: "/contabilidad/reportes/libro-diario",
    available: true,
  },
  {
    title: "Libro Mayor",
    description: "Resumen de movimientos por cuenta contable.",
    icon: FileBarChart,
    url: "/contabilidad/reportes/libro-mayor",
    available: true,
  },
  {
    title: "Validacion Mov. CXC",
    description: "Conciliacion de movimientos de cuentas por cobrar.",
    icon: Calculator,
    url: "/contabilidad/reportes/validacion-cxc",
    available: true,
  },
  {
    title: "Balance 8 Columnas",
    description:
      "Balance de comprobacion con saldo inicial, movimientos y saldo final.",
    icon: FileSpreadsheet,
    url: "/contabilidad/reportes/balance-8-columnas",
    available: true,
  },
  {
    title: "Estado de Situacion Financiera",
    description:
      "Balance general con activos, pasivos y patrimonio agrupados por categoria.",
    icon: Scale,
    url: "/contabilidad/reportes/estado-situacion",
    available: true,
  },
  {
    title: "Estado de Resultados",
    description:
      "Estado de ingresos, costos y gastos con calculo de utilidades (3 columnas).",
    icon: TrendingUp,
    url: "/contabilidad/reportes/estado-resultados",
    available: true,
  },
  {
    title: "Presupuesto vs Real",
    description:
      "Comparación del estado de resultados contra el presupuesto por cuenta y mes.",
    icon: GitCompareArrows,
    url: "/contabilidad/reportes/presupuesto-vs-real",
    available: true,
  },
  {
    title: "Auditoría de Publicaciones",
    description:
      "Historial de acciones de publicar y despublicar comprobantes.",
    icon: History,
    url: "/contabilidad/reportes/auditoria",
    available: true,
  },
  {
    title: "Cuentas por Pagar",
    description:
      "Saldo pendiente a proveedores por antigüedad (aging), por empresa.",
    icon: Wallet,
    url: "/contabilidad/reportes/cuentas-por-pagar",
    available: true,
  },
  {
    title: "Reconciliación CxP",
    description:
      "Cuadre del listado auxiliar de proveedores contra el mayor contable (2103001 / 2103002).",
    icon: ClipboardCheck,
    url: "/contabilidad/reportes/reconciliacion-cxp",
    available: true,
  },
  {
    title: "Libro de Compras",
    description:
      "Facturas de proveedor por empresa y período (SII / F29): neto, IVA, total.",
    icon: Receipt,
    url: "/contabilidad/reportes/libro-compras",
    available: true,
  },
];

export default function ReportesPage() {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto w-[80vw] space-y-6 py-6">
      <div>
        <h1 className="text-2xl font-bold">Reportes Contables</h1>
        <p className="text-sm text-muted-foreground">
          Consultas y reportes financieros
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {reports.map((report) => {
          const Icon = report.icon;
          return (
            <Card
              key={report.title}
              className={`cursor-pointer transition-all hover:shadow-md ${
                report.available
                  ? "hover:border-primary"
                  : "cursor-not-allowed opacity-50"
              }`}
              onClick={() => report.available && navigate(report.url)}
            >
              <CardHeader className="pb-2">
                <div className="flex items-center gap-2">
                  <div
                    className={`rounded-lg p-2 ${
                      report.available
                        ? "bg-primary/10 text-primary"
                        : "bg-muted text-muted-foreground"
                    }`}
                  >
                    <Icon className="h-5 w-5" />
                  </div>
                  <CardTitle className="text-base">{report.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription>{report.description}</CardDescription>
                {!report.available && (
                  <span className="mt-2 inline-block rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground">
                    Próximamente
                  </span>
                )}
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
